import type {
  InvoiceDebt,
  InvoiceDebtFilters,
  UseInvoiceDebtData,
} from '@models/invoiceDebt'
import type { PaginatedResponse } from '@models/pagination'
import type { AxiosError } from 'axios'
import { useQuery } from 'react-query'
import invoiceDebtsApi from './actions'
import { invoiceDebtsKeys } from './constants'

export const selectData = ({
  data,
  pagination,
}: PaginatedResponse<InvoiceDebt>): UseInvoiceDebtData => ({
  invoiceDebts: data,
  invoiceDebtsMap: new Map(
    data.map(invoiceDebt => [invoiceDebt.id, invoiceDebt]),
  ),
  pagination,
})

const useInvoiceDebts = (filters: InvoiceDebtFilters) =>
  useQuery<PaginatedResponse<InvoiceDebt>, AxiosError, UseInvoiceDebtData>(
    invoiceDebtsKeys.list(filters),
    () => invoiceDebtsApi.getInvoiceDebts(filters),
    { select: selectData, enabled: !!filters.companyId },
  )

export default useInvoiceDebts
